import {useMutation, useQueryClient} from '@tanstack/react-query';

import WhitelistRepository from '../../../networking/repos/WhitelistRepository';
import WhitelistUser from '../../../networking/models/WhitelistUser';
import {WhitelistQueryKey} from './Query';

export const useWhitelistSaveMutation = () => {
    const queryClient = useQueryClient();
    const repo = new WhitelistRepository();

    return useMutation({
        mutationFn: (email: WhitelistUser) => repo.save(email),
        onSuccess: () => queryClient.invalidateQueries(WhitelistQueryKey.base)
    });
};

export const useWhitelistDeleteMutation = () => {
    const queryClient = useQueryClient();
    const repo = new WhitelistRepository();

    return useMutation({
        mutationFn: (user: WhitelistUser) => repo.destroy(user),
        onSuccess: () => queryClient.invalidateQueries(WhitelistQueryKey.base)
    });
};
